import gsap, { Power0 } from 'gsap';

function useHambAnimation({
  firstMainLinePathRef,
  secondMainLinePathRef,
  thirdLineHamburgerRef,
}) {
  let tl = gsap
    .timeline({ yoyo: true, paused: true })
    .add(fadeOutExtraPath(thirdLineHamburgerRef))
    .add(animateCross(firstMainLinePathRef, secondMainLinePathRef), '<');

  return tl;
}

function animateCross(firstMainLinePathRef, secondMainLinePathRef) {
  let tl = gsap.timeline();

  animateFistPath(tl, firstMainLinePathRef);
  animateSecondPath(tl, secondMainLinePathRef);

  return tl;
}

function animateFistPath(tl, initialPath) {
  return tl.to(initialPath.current, {
    rotate: -45,
    x: 0,
    scale: 1.2,
    y: 7,
    delay: 0.1,
    transformOrigin: 'center',
    duration: 0.2,
    ease: Power0.easeInOut,
  });
}

function animateSecondPath(tl, initialPath) {
  return tl.to(
    initialPath.current,
    {
      rotate: 45,
      scale: 1.2,
      x: 0,
      y: 0,
      transformOrigin: 'center',
      duration: 0.2,
      ease: Power0.easeInOut,
    },
    '<',
  );
}

function fadeOutExtraPath(extraPath) {
  let tl = gsap.timeline({
    id: `fadeOutExtraPath`,
    delay: 0,
    repeatDelay: 0,
  });

  return tl.to(
    extraPath.current,
    {
      duration: 0.2,
      opacity: 0,
      ease: 'ease-in-out',
      y: 2,
    },
    '-=1',
  );
}

export default useHambAnimation;
